import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CategoryReviewerModel } from "src/app/views/Audit/project-overview/models/category-reviewer.model";
import { QuestionResponseModel } from "src/app/views/Audit/questions-table/question-response.model";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {

  private gsdApiUrl = environment.apiUrl;
  private createdOnMap: { [key: string]: string } = {};

  constructor(private http:HttpClient) { }
    
  setCreatedOn(auditId: number, categoryId: number, date: string) {
    const key = `${auditId}-${categoryId}`;
    this.createdOnMap[key] = date;
}

  getCreatedOn(auditId: number, categoryId: number): string {
    const key = `${auditId}-${categoryId}`;
    const date = this.createdOnMap[key];
    return date;
}
  
  getQuestions(categoryId: number): Observable<any> {
    const endPointUrl: string = `Audit/GetQuestionsByCategoryId?categoryId=${categoryId}`;
    return this.http.get(this.gsdApiUrl + endPointUrl);
  }

  getAuditResponseDropDown():Observable<any>{
    return this.http.get(`${this.gsdApiUrl}Audit/GetForResponseDropDown`);
  }

  getQuestionsResponse(auditId:number, categoryId:number): Observable<QuestionResponseModel[]>{
    const url = `${this.gsdApiUrl}Audit/GetAuditQuestionsResponse?auditid=${auditId}&categoryId=${categoryId}`;
    return this.http.get<QuestionResponseModel[]>(url);
  }

  submitCategoryBySubAuditor(data: any):Observable<any> {
    return this.http.post(this.gsdApiUrl + 'Audit/SubmitCategoryBySubAuditor', data, {responseType: 'text'});
  }

  saveSubAuditorCommentsForQuestionId(data: any):Observable<any> {
    return this.http.post(this.gsdApiUrl + 'Audit/SaveSubAuditorCommentsForQuestionId', data, {responseType: 'text'});
  }

  saveQuestionsResponse(data:any):Observable<any>{
    return this.http.post(this.gsdApiUrl + 'Audit/SaveAuditQuestionsResponse',data,{responseType: "text"});
  }

  SubmitCategory(auditId : number, categoryId : number):Observable<any>
  {
    const requestUrl = `${this.gsdApiUrl}Audit/SubmitCategory?auditId=${auditId}&categoryId=${categoryId}`;
    return this.http.post(requestUrl, {});
  }

  ClearCategoryResponse(categoryId : number, auditId : number):Observable<any>
  {
    const requestUrl = `${this.gsdApiUrl}Audit/ClearCategoryResponse?categoryId=${categoryId}&auditId=${auditId}`;
    return this.http.post(requestUrl, {});
  }
  
  saveCategoryReview(data:any):Observable<any>{
    return this.http.post(this.gsdApiUrl + 'Audit/ToCreateOrUpdateRatingsandComments',data,{responseType: "text"});
  }  

}